import {Injectable,ErrorHandler} from '@angular/core';
import {LogCat} from '../../common/log/services/log.manager.categories';
import {LogManager} from '../../common/log/services/log.manager';
import {ExceptionManager} from './exception.manager';

@Injectable()
export class WrapExceptionHandler implements ErrorHandler {

	constructor() {
	}

	public handleError(exception: any, stackTrace?: any, reason?: string): void {

		try {
			let msg = exception ? exception.toString() + '\n': 'Exception is undefined';
			LogManager.fatal(LogCat.ExceptionHandlerCategories.Uncaught, msg, exception);
			//this.exceptionManager.pushException(exception);
		} catch (err) {
			console.log(exception, exception.message);
		}
	}
}
